// extracted by mini-css-extract-plugin
export var menuItemTemplate = "{prismicMenuItem-url}-module--menu-item-template--fb377";